module.exports = __webpack_public_path__ + "static/media/battery.7f4ec76b.svg";